import React, {useEffect, useState} from 'react';
import ObservationsInputProperties from "./ObservationsInputProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import Textarea from '../../../ui_components/Textarea/Textarea';
import DescriptionIcon from '@mui/icons-material/Description';

const ObservationsInput: React.FC<ObservationsInputProperties> = ({
                                                                  value,
                                                                  placeholder,
                                                                  label,
                                                                  onChange,
                                                                  lines = 3,
                                                                  disabled,
                                                                  fullWidth = false,
                                                                  className = '',
                                                                  error
                                                              }) => {

    const [name, setName] = useState(value);
    const i18n = useI18nContext();

    useEffect(() => {
        setName(value);
    }, [value]);

    const text = label ?? i18n.translate("OBSERVATIONS");

    const onValueChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newName = event.target.value;
        setName(newName);
        onChange(newName);
    }

    return (
        <Textarea
            error={error}
            label={text}
            value={name}
            placeholder={placeholder}
            disabled={disabled}
            onBlur={onValueChange}
            startIcon={DescriptionIcon}
            className={className}
            fullWidth={fullWidth}
            lines={lines}
        />
    )
}


export default ObservationsInput;